module.exports = __webpack_public_path__ + "img/leaetherStripSmall.71d0cba5.jpg";